import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RegulationTracking = ({ data, onRefresh }) => {
  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-heading font-semibold text-foreground">Regulation Tracking</h3>
        <Button variant="outline" size="sm">
          <Icon name="Plus" size={16} className="mr-2" />
          Add Regulation
        </Button>
      </div>
      <div className="space-y-4">
        {data?.map((regulation) => (
          <div key={regulation?.id} className="p-4 border border-border rounded-lg">
            <div className="flex items-start justify-between mb-3">
              <div>
                <h4 className="text-sm font-medium text-foreground mb-1">{regulation?.regulation_name}</h4>
                <p className="text-xs text-muted-foreground">
                  Type: {regulation?.regulation_type?.toUpperCase()}
                </p>
              </div>
              <span
                className="px-2 py-1 rounded text-xs font-medium"
                style={{
                  backgroundColor:
                    regulation?.compliance_status === 'compliant' ?'var(--color-success)15' :'var(--color-error)15',
                  color:
                    regulation?.compliance_status === 'compliant' ?'var(--color-success)' :'var(--color-error)'
                }}
              >
                {regulation?.compliance_status?.replace(/_/g, ' ')}
              </span>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-3">
              <div>
                <p className="text-xs text-muted-foreground">Adherence Level</p>
                <p className="text-sm font-medium text-foreground">{regulation?.adherence_level || 0}%</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground">Risk Level</p>
                <p className="text-sm font-medium text-foreground capitalize">{regulation?.risk_level || 'N/A'}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground">Violations</p>
                <p className="text-sm font-medium text-foreground">{regulation?.violations_count || 0}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground">Next Assessment</p>
                <p className="text-sm font-medium text-foreground">
                  {regulation?.next_assessment_date
                    ? new Date(regulation?.next_assessment_date)?.toLocaleDateString()
                    : 'Not scheduled'}
                </p>
              </div>
            </div>

            {regulation?.remediation_plan && (
              <div className="p-3 bg-muted/50 rounded text-xs">
                <p className="font-medium text-foreground mb-1">Remediation Plan:</p>
                <p className="text-muted-foreground">{regulation?.remediation_plan}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RegulationTracking;